import { useSelector, useDispatch } from "react-redux"
import {
  selectGlobalState,
  saveFn as saveFnGlobal,
  deleteFn as deleteFnGlobal,
} from "@services/global-slice"

export const useAppState = () => {
  const dispatch = useDispatch()

  const global = useSelector(selectGlobalState)
  const saveFn: any = (val: any) => dispatch(saveFnGlobal(val))
  const deleteFn: any = (val: any) => dispatch(deleteFnGlobal(val))

  return {
    global,
    user: global.user,
    saveFn,
    deleteFn,
  }
}
